<template>
  <div>
  

    <vx-card>

 <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
             
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>{{campaignDescription.campaign_name}} Contacts</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
             <download-excel
            :data="records"
            :export-fields="json_fields"
            type="csv"
            name="unmatched_contacts.xls"
          >
            <vs-button icon="file_download" color="primary" type="filled">
              Export</vs-button
            >
          </download-excel>

            </vs-col>
          </vs-row>


            
      <vs-table class="mb-10" stripe :data="records">
        <template slot="thead">
          <vs-th sort-key="s_no">S No.</vs-th>
          <vs-th sort-key="Steps">Company</vs-th>
           <vs-th sort-key="Steps_description">Country</vs-th>
          <vs-th sort-key="Steps_description">Title</vs-th>
          <vs-th sort-key="Steps_description">Forename</vs-th>
          <vs-th sort-key="Steps_description">Surname</vs-th>
          <vs-th sort-key="Steps_description">Job Title</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td>
            <vs-td :data="data[indextr].conts_company">
              {{ data[indextr].conts_company }}
            </vs-td>
             <vs-td :data="data[indextr].conts_country">
              {{ data[indextr].conts_country }}
            </vs-td>
            <vs-td :data="data[indextr].conts_title">
              {{ data[indextr].conts_title }}
            </vs-td>
              <vs-td :data="data[indextr].conts_forename">
              {{ data[indextr].conts_forename }}
            </vs-td>
              <vs-td :data="data[indextr].conts_surname">
              {{ data[indextr].conts_surname }}
            </vs-td>
             <vs-td :data="data[indextr].conts_job_title">
              {{ data[indextr].conts_job_title }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from "@/config/abilities";
import axios from "@/axios.js";
import JsonExcel from "vue-json-excel";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";

export default {
  components: {
    downloadExcel: JsonExcel
  },
  data() {
    return {
            campaignDescription:[],

      json_fields: {
        Company: "conts_company",
        Country: "conts_country",
        Title: "conts_title",
         Forename: "conts_forename",
          Surname: "conts_surname",
          JobTitle: "conts_job_title"
      },
      campaignId: null,
      abilities: null,
      records: []
    };
  },
  computed: {},
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
        getCampaignDescription() {
      const campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          this.campaignDescription = res.data;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true;
            return;
          }
          console.error(err);
        });
    },
    getResult() {
      axios
        .post(this.$base_url + "/api/contacts/matched_csv_contacts", {
          campaignId: this.campaignId
        })
        .then(response => {
          this.records = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.getResult();
    this.getCampaignDescription()
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
     if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
